import { createStore } from 'effector'
import localeConfig from 'src/configs/locale'

const locale = createStore<{ language: string }>({
  language: localeConfig.language
})

export default locale
